const CLOUDFRONT_DOMAIN = 'https://d39whcrvr8utqs.cloudfront.net';
const BUCKET_NAME = 'shopnowindia';

export const getOptimizedImageUrl = (rawS3UrlOrPath, quality = 80, props, fit = 'contain') => {
  if (!rawS3UrlOrPath) return '';
  const targetSize = props.width  * 2;
  let cleanKey = rawS3UrlOrPath;

  // 1. Force remove the full S3 web address if present
  if (cleanKey.includes('://shopnowindia.s3.ap-south-1.amazonaws.com')) {
    cleanKey = cleanKey.split('://shopnowindia.s3.ap-south-1.amazonaws.com')[1];
  } else if (cleanKey.includes('://shopnowindia.s3.ap-south-1.amazonaws.com')) {
    cleanKey = cleanKey.split('://shopnowindia.s3.ap-south-1.amazonaws.com')[1];
  }

  // 2. Decode the "+" or "%20" browser values back to standard textual spaces
  cleanKey = decodeURIComponent(cleanKey.replace(/\+/g, ' '));
  if (cleanKey.startsWith('/')) {
    cleanKey = cleanKey.substring(1);
  }
// console.log(cleanKey)
  // 3. Assemble the AWS JSON configuration object
  const requestObject = {
    bucket: BUCKET_NAME,
    key: cleanKey,
    edits: {
      toFormat: 'webp',
      resize: {
        width: props.width,
        height: props.width // Maintains the 1:1 aspect ratio highlighted by Lighthouse
        // fit: fit
      },
      webp: { quality: quality }
    }
  };

  try {
    // 4. Encode directly to base64
    const jsonString = JSON.stringify(requestObject);
    const base64Request = btoa(unescape(encodeURIComponent(jsonString)));

    return `${CLOUDFRONT_DOMAIN}/${base64Request}`;
  } catch (error) {
    console.error("Base64 calculation error:", error);
    return rawS3UrlOrPath;
  }
};
